
export default function Chat() {

    return <></>;
}